import React, { Fragment, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { get } from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import Slider from 'react-slick'
import CustomModal from 'components/molecules/CustomModal/CustomModal'
import ContentBlock from 'components/atoms/ContentBlock/ContentBlock'
import Typography from 'components/atoms/Typography/Typography'
import Lightbox from 'components/molecules/Lightbox/Lightbox'
import Image from 'components/atoms/Image/Image'
import { userCheckMobileScreen } from 'helpers/tools'

import 'slick-carousel/slick/slick.css'
import './ExtendedImagesGrid.scss'

function ExtendedImagesGrid({ data }) {
  const isMobile = userCheckMobileScreen()
  const title = get(data, 'title')
  const description = get(data, 'description.value')
  const items = get(data, 'items')
  const themeClasses = get(data, 'theme.entity.classes')
  const slickRef = useRef(null)
  const [openImage, setOpenImage] = useState(false)
  const setting = {
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <Container className={`extended-images-grid ${themeClasses} pt-4 pb-5`} fluid>
      <CustomModal open={openImage} closeModal={() => setOpenImage(false)} minimizeMobile>
        <Slider ref={slickRef} {...setting}>
          {items.map(({ entity }) => (
            <Fragment key={get(entity, 'uuid')}>
              <div className="d-flex justify-content-between extended-images-grid__modal">
                <button onClick={() => slickRef.current.slickPrev()}>
                  <i className="icone-chevron-left" />
                </button>
                <Image
                  src={
                    isMobile
                      ? get(entity, 'media.entity.images.medium.url')
                      : get(entity, 'media.entity.images.wide.url')
                  }
                />
                <button onClick={() => slickRef.current.slickNext()}>
                  <i className="icone-chevron-right" />
                </button>
              </div>
              <div className="d-flex align-items-center flex-column">
                <Typography cssClass="lightbox__title">{get(entity, 'title')}</Typography>
                <Typography cssClass="lightbox__subtitle mb-2">{get(entity, 'subtitle')}</Typography>
              </div>
            </Fragment>
          ))}
        </Slider>
      </CustomModal>

      <Container>
        <Row>
          <Col sm={12}>
            <ContentBlock>
              {title && (
                <Typography variant="h2" color="primary" cssClass="extended-images-grid__title title-bold-md">
                  {title}
                </Typography>
              )}
              {description && (
                <Typography
                  variant="span"
                  color="gray-100"
                  cssClass="extended-images-grid__description bloco-conteudo-preview"
                >
                  {ReactHtmlParser(description)}
                </Typography>
              )}
            </ContentBlock>
          </Col>
        </Row>
        <Row className="pt-4">
          {items.map(({ entity }, index) => (
            <Col xs={6} md={3} key={get(entity, 'uuid')}>
              <Lightbox
                allImages={items.map(({ entity }) => ({
                  image: get(entity, 'media.entity.images'),
                  title: get(entity, 'title'),
                  subtitle: get(entity, 'subtitle'),
                }))}
                index={index}
                title={get(entity, 'title')}
                subtitle={get(entity, 'subtitle')}
                image={
                  isMobile ? get(entity, 'media.entity.images.medium.url') : get(entity, 'media.entity.images.wide.url')
                }
              >
                {get(entity, 'description.value')}
              </Lightbox>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  )
}

export default ExtendedImagesGrid
